function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { asyncImportScript } from '../modules/_asyncImportScript';
import { Cloudinary } from 'cloudinary-core';
var cloudinaryCss = 'https://vjs.zencdn.net/7.10.2/video-js.min.css';
var cloudinaryJs = 'https://vjs.zencdn.net/7.10.2/video.min.js';
var VIDEOSELECTOR = 'video-js';
var VIDEOCLOUDINARYSELECTOR = 'video-js--cloudinary';
var VIDEOYOUTUBESELECTOR = 'video-js--youtube';
var cldOpt = {
  cdn_subdomain: true,
  private_cdn: true,
  cloud_name: 'leroymerlin',
  secure: true
};
var cldVideoOptions = {
  resource_type: 'video',
  preload: 'auto',
  streaming_profile: 'hd/DAMEO',
  source_types: ['m3u8', 'mpd'],
  source_transformation: {
    'm3u8': [{
      streaming_profile: 'sp_hd',
      format: 'm3u8'
    }],
    'mpd': [{
      streaming_profile: 'sp_hd',
      format: 'mpd'
    }]
  }
};
var videoFormats = [{
  name: 'HLS',
  type: 'application/x-mpegurl',
  format: 'm3u8'
}, {
  name: 'DASH',
  type: 'application/dash+xml',
  format: 'mpd'
}];
var Video = /*#__PURE__*/function () {
  function Video() {
    _classCallCheck(this, Video);
    this.prmVideos = document.querySelectorAll(".".concat(VIDEOSELECTOR));
    showVideos.call(this);
    initYoutubeVideo.call(this);
  }
  return _createClass(Video, [{
    key: "pauseVideos",
    value: function pauseVideos() {
      // check if brightcove already init video (videos lazyloaded with intersectionObserver)
      if (typeof videojs !== 'undefined') {
        var players = videojs.getAllPlayers();
        for (var i = 0; i < players.length; i++) {
          players[i].pause();
        }
      }
    }
  }]);
}();
function initYoutubeVideo() {
  var createEmbeded = function createEmbeded(videoContainer) {
    var _videoContainer$datas = videoContainer.dataset,
      videoId = _videoContainer$datas.videoId,
      width = _videoContainer$datas.width,
      height = _videoContainer$datas.height;
    var frame = document.createElement('iframe');
    frame.classList.add('ka-video__frame');
    frame.width = parseInt(width, 10) || videoContainer.offsetWidth;
    frame.height = parseInt(height, 10) || videoContainer.offsetHeight;
    frame.src = "https://www.youtube.com/embed/".concat(videoId, "?showinfo=0&rel=0&autoplay=1");
    frame.title = 'YouTube video player';
    frame.setAttribute('frameborder', '0');
    frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    frame.setAttribute('allowfullscreen', 'true');
    videoContainer.innerHTML = '';
    videoContainer.appendChild(frame);
  };
  document.querySelectorAll(".".concat(VIDEOYOUTUBESELECTOR)).forEach(function (videoContainer) {
    videoContainer.addEventListener('playVideo', function () {
      createEmbeded(videoContainer);
    });
    videoContainer.querySelector('.js-start-video-btn').addEventListener('click', function () {
      createEmbeded(videoContainer);
    });
  });
}
function showVideos() {
  this.observer = new IntersectionObserver(_lazyLoadVideo.bind(this), {
    root: null,
    rootMargin: '0px',
    threshold: 0
  });
  for (var i = 0; i < this.prmVideos.length; i++) {
    this.observer.observe(this.prmVideos[i]);
  }
}
function concatSources(url) {
  var sources = '';
  var _iterator = _createForOfIteratorHelper(videoFormats),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var type = _step.value;
      sources += "<source src=".concat(url, ".").concat(type.format, " type=").concat(type.type, " />");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return sources;
}
function checkLinks(url) {
  var linkTags = document.getElementsByTagName('link');
  for (var i = linkTags.length; i--;) {
    if (linkTags[i].href === url) return true;
  }
  return false;
}
function checkScripts(url) {
  var scriptTags = document.getElementsByTagName('script');
  for (var i = scriptTags.length; i--;) {
    if (scriptTags[i].src === url) return true;
  }
  return false;
}
function _lazyLoadVideo(prmEntries) {
  // loop on all observers videos
  for (var i = 0; i < prmEntries.length; i++) {
    // check if video is visible in viewport
    if (prmEntries[i].isIntersecting) {
      if (prmEntries[i].target.classList.contains(VIDEOCLOUDINARYSELECTOR)) {
        if (!checkLinks(cloudinaryCss)) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.type = 'text/css';
          link.href = cloudinaryCss;
          link.media = 'all';
          document.head.appendChild(link);
        }
        if (!checkScripts(cloudinaryJs)) {
          asyncImportScript(cloudinaryJs);
        }
        var cdlPlayers = document.querySelectorAll(".".concat(VIDEOCLOUDINARYSELECTOR));
        for (var _i = 0; _i < cdlPlayers.length; _i++) {
          var videoId = cdlPlayers[_i].dataset.id;
          var cld = new Cloudinary(cldOpt);
          var videoUrl = cld.url(videoId, cldVideoOptions);
          var sources = concatSources(videoUrl);
          cdlPlayers[_i].insertAdjacentHTML('afterbegin', sources);
        }
      } else {
        asyncImportScript("//players.brightcove.net/".concat(prmEntries[i].target.getAttribute('data-account'), "/").concat(prmEntries[i].target.getAttribute('data-player'), "_default/index.min.js"));
      }
      this.observer.unobserve(prmEntries[i].target);
    }
  }
}
export default Video;